export default "/images/15e98db779f6f15faf52fa788f6c0513.avif";